import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


import "./Carrinho.css";

import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";

import VerificaToken from "../../components/utils/VerificaToken";

import CarrinhoLista from "./components/carrinhoLista/CarrinhoLista";
import CarrinhoResumo from "./components/carrinhoResumo/CarrinhoResumo";
import CarrinhoEntrega from "./components/carrinhoEntrega/CarrinhoEntrega";

export default function Carrinho() {

    const [mensagemPedido, setMensagemPedido] = useState("");

    const navigate = useNavigate();

    const [menuOpen, setMenuOpen] =
        useState(false);

    const [loading, setLoading] =
        useState(true);

    const [usuario, setUsuario] =
        useState({
            login: false,
            codcliente: null,
            tipo: ""
        });

    const [produtos, setProdutos] =
        useState([]);

    useEffect(() => {

        async function carregar() {

            const dados =
                await VerificaToken();
           // console.log("dados", dados)
            if (!dados.login) {
                navigate("/");
                return;
            }

            setUsuario(dados);

            const carrinho =
                JSON.parse(
                    localStorage.getItem("carrinho")
                ) || [];

            if (carrinho.length === 0) {
                setProdutos([]);
                setLoading(false);
                return;
            }


            setProdutos(carrinho);

            setLoading(false);

        }

        carregar();

    }, []);

    function atualizarCarrinho(
        novoCarrinho
    ) {

        setProdutos(
            novoCarrinho
        );

        localStorage.setItem(
            "carrinho",
            JSON.stringify(
                novoCarrinho
            )
        );

    }

    if (loading) {

        return (

            <>
                <Navbar />

                <TopLinks
                    onOpenMenu={() =>
                        setMenuOpen(true)
                    }
                />

                <Menu
                    isOpen={menuOpen}
                    onClose={() =>
                        setMenuOpen(false)
                    }
                />

                <div className="pagina-carrinho-loading">

                    Carregando carrinho...

                </div>

                <Footer />

            </>

        );

    }

    return (

        <>

            <Navbar />

            <TopLinks
                onOpenMenu={() =>
                    setMenuOpen(true)
                }
            />

            <Menu
                isOpen={menuOpen}
                onClose={() =>
                    setMenuOpen(false)
                }
            />

            <div className="pagina-carrinho">

                <div className="titulo-carrinho">

                    <h1>
                        Meu Carrinho
                    </h1>


                </div>

                {

                    produtos.length === 0

                        ?

                        (
                            <div className="carrinho-vazio">

                                <h2>
                                    {mensagemPedido
                                        ? mensagemPedido
                                        : "Seu carrinho está vazio."}
                                </h2>

                                <p>
                                    {mensagemPedido
                                        ? "Seu pedido foi enviado para análise e será processado em breve."
                                        : "Adicione produtos para começar seu pedido."}
                                </p>


                                <div className="carrinho-vazio-botoes">

                                    <button
                                        className="btn-continuar-comprando"
                                        onClick={() => navigate("/")}
                                    >
                                        Continuar Comprando
                                    </button>

                                    {mensagemPedido && (

                                        <button
                                            className="btn-acompanhar-pedido"
                                            onClick={() => navigate("/pedidos")}
                                        >
                                            Acompanhar Pedido
                                        </button>

                                    )}

                                </div>

                            </div>
                        )

                        :

                        (

                            <div className="carrinho-conteudo">

                                <div className="carrinho-esquerda">

                                    <CarrinhoLista
                                        produtos={produtos}
                                        setProdutos={atualizarCarrinho}
                                        usuario={usuario}
                                        limitecrdt={usuario.limitecrdt}
                                    />

                                </div>

                                <div className="carrinho-direita">

                                    <CarrinhoResumo
                                        produtos={produtos}
                                        limitecrdt={usuario.limitecrdt}
                                        codcliente={usuario.codcliente}
                                        razaosocial={usuario.razaosocial}
                                        codplano={usuario.codplano}
                                        codrepresentante={usuario.representante}
                                        setProdutos={setProdutos}
                                        setMensagemPedido={setMensagemPedido}
                                    />

                                    <CarrinhoEntrega />

                                </div>

                            </div>

                        )

                }

            </div>

            <BTNtoTop />

            <Footer />

        </>

    );

}